import Multimap from 'multimap';

export default class MultiMap extends Multimap {
	has(key, value) {
		const result = super.get(key, value);
		if(result && result.length > 0) {
			return true;
		}
		return false;
	}

	getFirst(key) {
		if(!this.has(key)) {
			return null;
		}
		let foundItem = this.get(key);
		if(foundItem[0]) {
			foundItem = foundItem[0];
		}
		return foundItem;
	}
}